//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

// The one place these two raw hex values are allowed to exist (constitution
// Principle II names ToolCallBox/ToolCallDetails as their home). Every
// consumer — ToolCallBox itself, plus TurnTraceControl and TurnTracePanel,
// which deliberately match the same card look — imports these constants
// instead of repeating the literal, so there is exactly one definition to
// drift from rather than three. Tailwind's class scanner reads these as
// plain text wherever this file is included in `content` (`tailwind.config.js`
// already globs `src/**/*.{js,ts,jsx,tsx}`), so a template literal built from
// a bare hex constant would NOT work here — the full class name must appear
// verbatim in scanned source, which is why these are complete class strings,
// not raw hex values to be interpolated.
export const TOOL_CARD_BORDER_CLASS = 'border-[#E2E8F0]';
export const TOOL_CARD_BG_CLASS = 'bg-[#F8F9FE]';
